export default __webpack_public_path__ + "static/media/signupwith.ad966364.png";